import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import KeyFeatures from "./sections/KeyFeatures";
import OnDemandPreview from "./sections/OnDemandPreview";
import SponsorHighlights from "./sections/SponsorHighlights";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <Hero />
      <KeyFeatures />
      <OnDemandPreview />
      <SponsorHighlights />
      <Footer />
    </div>;
}